import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/views/layout/Index'
import Store from '@/store'
import { filterAsyncRouter } from '@/utils/Methods';
Vue.use(VueRouter)
// 解决ElementUI导航栏中的点击当前路由的报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
/**
 * 如需使用keep alive,路由name必须和组件name保持一致且全局唯一
 */
export const constantRoutes = [
  {
    path: '/auth_login',
    name: 'auth_login',
    meta: {
      title: '登录'
    },
    component: () => import('@/views/auth/login.vue')
  },
  {
    path: '/',
    name: '_home',
    meta: {
      title: '首页'
    },
    redirect: '/project/Index',
    component: () => import('@/views/layout/Index'),
    children: [
      {
        path: 'redirect/*',
        name: 'redirect',
        meta: {
          title: '重定向'
        },
        component: () => import('@/views/layout/Redirect')
      },
      {
        path: '/basicLibrary/exam-design',
        name: 'exam-design',
        meta: {
          title: '题目设计'
        },
        component: () => import('@/views/basicLibrary/exam/ExamDesign')
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  routes: constantRoutes
})
router.beforeEach((to, from, next) => {
  // 修改title
  // auth_login
  window.document.title = to.meta.title || '企业智慧管理云平台'
  if (!to.path.includes('/auth_login')) {
    // 如果没有token自动退出登录
    if (!Store.state.token) {
      window.location.href = '/auth_login'
    }
    // 如果菜单没了，重新获取
    if (!Store.state.menu.length) {
      Store.dispatch('SetUserInfo').then(() => {
        Store.dispatch('SetMenu').then(res => {
          const asyncRouterMap = JSON.parse(JSON.stringify(res))
          const accessedRoutes = filterAsyncRouter(asyncRouterMap)
          router.addRoutes([...accessedRoutes, {
            path: '*',
            name: '_404',
            meta: {
              title: '404'
            },
            redirect: '/404',
            component: Layout,
            children: [
              {
                path: '404',
                name: '404',
                meta: {
                  title: '404'
                },
                component: () => import('@/views/NotFound')
              }
            ]
          }])
          next({ ...to, replace: true })
        })
      })
    }
    next()
  } else {
    next()
  }
})

export default router
